/* eslint-disable linebreak-style */
export const ADD_MISSION = 'spaceTravels/missions/ADD_MISSION';
export const JOIN_MISSION = 'spaceTravels/missions/JOIN_MISSION';
